import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../styles";

function Title({ title, btnName, link, btnIcon }) {

  return (
    <div className="d-flex align-items-center justify-content-between mb-4">
      <div className=" pry-text">
        <h5>{title}</h5>
      </div>
      {btnName &&
        <div className={``}>
          <Link to={link}>
            <Button pry className="btn me-auto d-flex align-items-center ">
              {btnIcon}
              <span className="ps-2">
                {btnName}
              </span>
            </Button>
          </Link>
        </div>
      }
    </div>
  );
}

export default Title;


